"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var acc_address_1 = require("../../../types/address/acc-address");
/**
 *
 */
var BaseAccount = /** @class */ (function () {
    /**
     *
     * @param address
     * @param public_key
     * @param coins
     * @param account_number
     * @param sequence
     */
    function BaseAccount(address, public_key, coins, account_number, sequence) {
        if (coins === void 0) { coins = []; }
        if (account_number === void 0) { account_number = 0; }
        if (sequence === void 0) { sequence = 0; }
        this.address = address;
        this.public_key = public_key;
        this.coins = coins;
        this.account_number = account_number;
        this.sequence = sequence;
    }
    /**
     *
     * @param value
     */
    BaseAccount.fromJSON = function (value) {
        return new BaseAccount(!!value.address ? acc_address_1.AccAddress.fromBech32(value.address) : undefined, !!value.public_key ? value.public_key : undefined, value.coins, value.account_number, value.sequence);
    };
    return BaseAccount;
}());
exports.BaseAccount = BaseAccount;
